// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WheelOfFortune.css */

.spin-page {
  height: 80vh; /* повна висота вікна */
  flex-direction: column;
  justify-content: space-between; /* Забезпечує, щоб елементи були на верхній та нижній частині */
  align-items: center;
  background: transparent;
  color: white;
  text-align: center;
}

.spin-content {
  flex-grow: 1; /* Це дозволяє відділяти вміст від кнопки/таймера */
  display: flex;
  flex-direction: column;
  justify-content: center; /* Вирівнює вміст по центру */
  align-items: center;
}

.timer-counter,
.spin-button {
  margin-top: 20px;
}

.tap-button-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.wheel-container {
  position: relative;
  width: 80vw;
  height: 80vw;
  border-radius: 50%;
  background: linear-gradient(135deg, #1a1a3d, #3c3c7c);
  border: 2px solid #ffffff30;
  overflow: hidden;
  margin-bottom: 5vw;
}

.spin-button {
  width: 50vw;
  height: 12vw;
  background: linear-gradient(to bottom, #d358e7, #0f165e);
  color: white;
  font-size: 5vw;
  font-weight: 600;
  border-radius: 10vw;
  border: none;
  cursor: pointer;
  transition: transform 0.2s;
  margin-top: 20px; /* Додано відступ між колесом та кнопкою */
}

.spin-button:active {
  transform: scale(0.95);
}

.spin-button:disabled {
  background: gray;
  cursor: not-allowed;
}

.timer-counter {
  display: none;
  visibility: hidden;
  color: transparent;
}

.ad-modal {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50vh; /* Висота пів екрану */
  background: #000;
  color: white;
  z-index: 1000;
  padding: 20px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  animation: slideUp 0.3s ease-out;
  overflow-y: auto;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.5);
}

.ad-modal-content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.ad-modal-content > * {
  flex: 1 1;
}

.close-modal {
  position: absolute;
  top: 10px;
  right: 15px;
  background: transparent;
  color: white;
  border: none;
  font-size: 24px;
  cursor: pointer;
  z-index: 1001;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/spin.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,YAAY,EAAE,uBAAuB;EACrC,sBAAsB;EACtB,8BAA8B,EAAE,+DAA+D;EAC/F,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY,EAAE,mDAAmD;EACjE,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,6BAA6B;EACtD,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wDAAwD;EACxD,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,gBAAgB,EAAE,0CAA0C;AAC9D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY,EAAE,sBAAsB;EACpC,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* WheelOfFortune.css */\n\n.spin-page {\n  height: 80vh; /* повна висота вікна */\n  flex-direction: column;\n  justify-content: space-between; /* Забезпечує, щоб елементи були на верхній та нижній частині */\n  align-items: center;\n  background: transparent;\n  color: white;\n  text-align: center;\n}\n\n.spin-content {\n  flex-grow: 1; /* Це дозволяє відділяти вміст від кнопки/таймера */\n  display: flex;\n  flex-direction: column;\n  justify-content: center; /* Вирівнює вміст по центру */\n  align-items: center;\n}\n\n.timer-counter,\n.spin-button {\n  margin-top: 20px;\n}\n\n.tap-button-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.wheel-container {\n  position: relative;\n  width: 80vw;\n  height: 80vw;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #1a1a3d, #3c3c7c);\n  border: 2px solid #ffffff30;\n  overflow: hidden;\n  margin-bottom: 5vw;\n}\n\n.spin-button {\n  width: 50vw;\n  height: 12vw;\n  background: linear-gradient(to bottom, #d358e7, #0f165e);\n  color: white;\n  font-size: 5vw;\n  font-weight: 600;\n  border-radius: 10vw;\n  border: none;\n  cursor: pointer;\n  transition: transform 0.2s;\n  margin-top: 20px; /* Додано відступ між колесом та кнопкою */\n}\n\n.spin-button:active {\n  transform: scale(0.95);\n}\n\n.spin-button:disabled {\n  background: gray;\n  cursor: not-allowed;\n}\n\n.timer-counter {\n  display: none;\n  visibility: hidden;\n  color: transparent;\n}\n\n.ad-modal {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 50vh; /* Висота пів екрану */\n  background: #000;\n  color: white;\n  z-index: 1000;\n  padding: 20px;\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  animation: slideUp 0.3s ease-out;\n  overflow-y: auto;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.5);\n}\n\n.ad-modal-content {\n  position: relative;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.ad-modal-content > * {\n  flex: 1;\n}\n\n.close-modal {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  background: transparent;\n  color: white;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  z-index: 1001;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(100%);\n  }\n  to {\n    transform: translateY(0%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
